// this is Vuex module for User (https://vuex.vuejs.org/)

import { SET_USER_INFO, RESET_USER_INFO, LOGIN, LOGOUT } from '../actions/user'
import { RESET_PRACTICE_LIST } from '../actions/practices'
import axios from 'axios'
import jwt_decode from 'jwt-decode'

const token = sessionStorage.getItem('token') || null

const state = {
    token,
    userId: token && jwt_decode(token).sub
}

const getters = {
    isAuthenticated: s => !!s.userId,
}

const mutations = {
    [SET_USER_INFO]: (state, info) => {
        state.token = info.token
        state.userId = info.userId
    },
    [RESET_USER_INFO]: (state) => {
        state.token = ''
        state.userId = null
    }
}

const actions = {
    [LOGIN]: ({ commit }, credentials) => {

        var request = {
            clientId: credentials.userName,
            clientSecret: credentials.password
        }

        return axios.post('/api/account/login', request).then(result => {
            const token = result.data.token
            const decoded = jwt_decode(result.data.token)

            commit(SET_USER_INFO, {
                token,
                userId: decoded.sub
            })

            sessionStorage.setItem('token', token)
        }).catch(error => {
            commit(RESET_PRACTICE_LIST)
            commit(RESET_USER_INFO)
            sessionStorage.setItem('token', '')

            throw Error('Invalid user name or password')
        });
    },
    [LOGOUT]: ({ commit }) => {
        commit(RESET_USER_INFO)
        commit(RESET_PRACTICE_LIST)
        sessionStorage.setItem('token', '')
    }
}

export default {
    state,
    getters,
    actions,
    mutations,
}
